require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./ar-eg-region-اوروبا-واسيا-الوسطى.json") })
        }
      }, "path---ar-eg-region-اوروبا-واسيا-الوسطى");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---ar-eg-region-اوروبا-واسيا-الوسطى!./.cache/json/ar-eg-region-اوروبا-واسيا-الوسطى.json
// module id = 445
// module chunks = 231608221292675